import { IntlFormatters } from 'react-intl';

import { Region } from 'utils/environment/types';

import { IUserFormData } from './types';
import {
  validateDateOfBirth,
  validateEmail,
  validateName,
  validatePhoneNumber,
  validateZipCode,
} from './utils';

interface IGetFormErrorsParams {
  formatMessage: IntlFormatters['formatMessage'];
  region: Region;
  simplePhoneValidation?: boolean;
}
export const getFormErrors = ({
  formatMessage,
  region,
  simplePhoneValidation,
}: IGetFormErrorsParams) => async (formData: IUserFormData) => {
  const emailErrors = validateEmail({ formData, formatMessage });

  const nameErrors = validateName({ formData, formatMessage });

  const phoneNumberErrors = await validatePhoneNumber({
    formData,
    formatMessage,
    region,
    simpleValidation: simplePhoneValidation,
  });

  const dateOfBirthErrors = validateDateOfBirth({ formData, formatMessage, region });

  const zipCodeErrors = validateZipCode({ formData, formatMessage, region });

  return {
    ...emailErrors,
    ...nameErrors,
    ...phoneNumberErrors,
    ...dateOfBirthErrors,
    ...zipCodeErrors,
  };
};
